import React, { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Container } from '../../../../Components';
import { CompliancesDue as LawCompliancesDue } from './LawCompliances/Due';
import { CompliancesDone as LawCompliancesDone } from './LawCompliances/Done';
import { CompliancesDue as RequirementCompliancesDue } from './RequirementCompliances/Due';
import { CompliancesDone as RequirementCompliancesDone } from './RequirementCompliances/Done';
import { ChangesToAcknowledge } from './Changes/Unacknowledged';
import { AcknowledgedChanges } from './Changes/Acknowledged';
import { ModuleContext } from '../../../../Context/ModuleContext/ModuleContext';

export const Statistics = () => {
  const { formatMessage } = useIntl();
  const { setHeader } = useContext(ModuleContext);

  useEffect(() => {
    setHeader(formatMessage({ id: 'law-portal.statistics.header', defaultMessage: 'Statistics' }), [
      {
        title: formatMessage({ id: 'law-portal.statistics.sub-menu.compliances.due' }),
        to: `/law-portal/statistics/law-compliances/due`,
      },
      {
        title: formatMessage({ id: 'law-portal.statistics.sub-menu.compliances.done' }),
        to: `/law-portal/statistics/law-compliances`,
      },
      {
        title: formatMessage({ id: 'law-portal.statistics.sub-menu.requirement-compliances.due' }),
        to: `/law-portal/statistics/requirement-compliances/due`,
      },
      {
        title: formatMessage({ id: 'law-portal.statistics.sub-menu.requirement-compliances.done' }),
        to: `/law-portal/statistics/requirement-compliances`,
      },
    ]);
  }, [setHeader, formatMessage]);

  return (
    <Container fullWidth>
      <Routes>
        <Route path="changes/unacknowledged" element={<ChangesToAcknowledge />} />
        <Route path="changes/acknowledged" element={<AcknowledgedChanges />} />
        <Route path="law-compliances/due" element={<LawCompliancesDue />} />
        <Route path="law-compliances" element={<LawCompliancesDone />} />
        <Route path="requirement-compliances/due" element={<RequirementCompliancesDue />} />
        <Route path="requirement-compliances" element={<RequirementCompliancesDone />} />
        <Route index element={<Navigate to="law-compliances/due" replace />} />
      </Routes>
    </Container>
  );
};